import { forwardersReducer, initialState as forwardersState } from './slices/forwarders';
import { sourcesReducer, initialState as sourcesState } from './slices/sources';
import { uiReducer, initialState as uiState } from './slices/ui';

export const initialState = {
	forwarders: forwardersState,
	sources: sourcesState,
	ui: uiState
};

export default {
	forwarders: forwardersReducer,
	sources: sourcesReducer,
	ui: uiReducer
};
